import { render, staticRenderFns } from "./xueshu.vue?vue&type=template&id=0b7bc97a&scoped=true&"
import script from "./xueshu.vue?vue&type=script&lang=js&"
export * from "./xueshu.vue?vue&type=script&lang=js&"
import style0 from "./xueshu.vue?vue&type=style&index=0&id=0b7bc97a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7bc97a",
  null
  
)

export default component.exports